import React, { useState } from "react";
import ReviewModal from "./ReviewModal";
import {useNavigate} from "react-router-dom";

const ReviewHistoryCard = ({ orderItem }) => {
    var navigate = useNavigate();
    const [isModalOpen, setModalOpen] = useState(false);

    const reviewPoint = Math.floor(Number(orderItem.orderPrice * 0.03));

    const handleReview = () => {

        setModalOpen(false)
    }

    return (
        <>
            <div className="mypage-review-card">
                <div className="mypage-review-info">
                    <div className="mypage-review-image">
                        <img src={orderItem.thumbnailPath} alt={orderItem.itemName} />
                    </div>
                    <div className="mypage-review-details">
                        {/*<p className="mypage-review-status">{orderItem.orderStatus}</p>*/}
                        <p className="mypage-review-date-time">{orderItem.orderDate} {orderItem.time} 결제</p>
                        <h4 className="product-title">{orderItem.itemName}</h4>
                        <p className="mypage-review-quantity">{orderItem.count}개 {orderItem.subscriptionPeriod}개월</p>
                        <p className="mypage-review-price">{orderItem.orderPrice?.toLocaleString()}원</p>
                        <a href="#" className="mypage-review-order-detail" onClick={() =>navigate(`/mypage/purchase/detail/${orderItem.orderId}`)}>주문상세 &gt;</a>
                    </div>
                </div>

                {/* 우측 버튼 */}
                <div className="mypage-review-actions">
                    {orderItem.orderPrice && <span className="mypage-review-reward">💎 리뷰쓰면 {reviewPoint}P 지급!</span>}
                    <button className="mypage-review-btn" onClick={() => setModalOpen(true)}>리뷰쓰기</button>
                </div>
            </div>

            {/* 팝업 연결 */}
            {isModalOpen && <ReviewModal onClose={handleReview} orderItem={orderItem} />}
        </>
    );
};

export default ReviewHistoryCard;
